import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findMRecordDetail,
	openSearchMRecordModal
} from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['searchMRecordListReducer', 'searchMRecordList']),
	activePage: 1,
	itemPerPage: 100,
	totalPage: 1,
	pagingMaxButtons: 1,
	fields: {
		epc: 'EPC',
		order_label_id: '洗標條碼',
		order_id: '訂單編號',
		note: '註記',
		order_date: '訂單時間',
		code: '序號',
		customer_name: '客戶名稱',
		organization: '單位',
		unit: '',
		owner: '姓名',
		discard: '不再使用',
		create_time: '維修時間'
	},
	keys: ['card_id', 'cat'],
	disableAdd: true,
	disableEdit: false,
	hidePaging: true,
	edit0: {
		className: 'glyphicon glyphicon-list-alt',
		showText: ''
	}
})

const mapDispatchToProps = (dispatch) => ({
	refresh: (payload) => {
	},
	changeActivepage: (pagingData) => {
		//不分頁，不處理
	},
	handleEdit: (pk) => {
		dispatch(findMRecordDetail(pk));
		dispatch(openSearchMRecordModal());
	}
})

const SearchMRecordListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default SearchMRecordListContainer;


// WEBPACK FOOTER //
// ./src/containers/SearchMRecordListContainer.jsx